// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox'>;

const SvgIcoInformationS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm.025 9h-.05a.978.978 0 0 0-.975.976v6.048c0 .537.439.976.976.976h.049a.979.979 0 0 0 .975-.976v-6.048a.978.978 0 0 0-.975-.976zM13 6h-2v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);

export default SvgIcoInformationS;
